import http from 'hub-http/clients/apiClient';
const BASE_URI = '/multi-currency/v2/currencies';
export const fetchPortalCurrencies = () => http.get(`${BASE_URI}/information`);